import * as React from "react";
import type { SVGProps } from "react";
const SvgWarningCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#warning-circle_svg__a)">
      <path d="M12 15c-.55 0-1-.45-1-1V7c0-.55.45-1 1-1s1 .45 1 1v7c0 .55-.45 1-1 1M12 18c-.26 0-.52-.11-.71-.29-.18-.19-.29-.45-.29-.71s.11-.52.29-.71c.28-.28.72-.37 1.09-.21.13.05.23.12.33.21.19.19.29.45.29.71s-.1.52-.29.71c-.1.09-.2.16-.33.21-.12.06-.25.08-.38.08" />
      <path d="M12 22C6.49 22 2 17.51 2 12S6.49 2 12 2s10 4.49 10 10-4.49 10-10 10m0-18c-4.41 0-8 3.59-8 8s3.59 8 8 8 8-3.59 8-8-3.59-8-8-8" />
    </g>
    <defs>
      <clipPath id="warning-circle_svg__a">
        <path fill="#fff" d="M2 2h20v20H2z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgWarningCircle;
